














































































import { Vue, Component } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import { PesiImballo } from '@/entity/Pk/PesiImballi'

@Component({
    components: {
        SearchFilter
    }
})

export default class PesiImballiSearch extends Vue {
    ready: boolean = true;
    filterSelected: boolean = false;
    CodeIdFilter: string = "";
    DescriptionFilter: string = "";
    resultsItems: any = {
        resultPage: new Array<PesiImballo>(),
        total: 0
    };
    page: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    showLoading: boolean = false;

    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }


    searchFilter(genericSearch: string) {
        if (genericSearch != undefined)
            this.freeText = genericSearch;

        this.searchPesiImballiAsync(true)
    }

    async searchPesiImballiAsync(start: boolean) {
        this.showLoading = true;
        if (start == true) {
            this.resetSearch();
        }
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/pk/GetPesiImballoWithFilterAndPagination'),
                data: {
                    FreeText: this.freeText,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'json'
            });
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;
            this.showLoading = false;

        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }
    }



}
